import React, { useEffect, useState } from 'react';
import { fetchCaseStudies } from '../../lib/api';
import { Star, Quote } from 'lucide-react';

const TestimonialWall = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchCaseStudies().then((all) => {
      setItems(all.filter((c) => c.testimonial?.quote).map((c) => ({ ...c.testimonial, industry: c.industry, client: c.client })));
    }).catch(() => setItems([]));
  }, []);

  if (!items.length) return null;
  const row1 = items.filter((_, i) => i % 2 === 0);
  const row2 = items.filter((_, i) => i % 2 === 1);

  const Card = ({ t }) => (
    <div className="w-[340px] shrink-0 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex gap-0.5">{[...Array(5)].map((_, i) => <Star key={i} className="h-3.5 w-3.5 text-amber-400 fill-amber-400" />)}</div>
      <p className="mt-3 text-sm text-slate-700 leading-relaxed line-clamp-4">"{t.quote}"</p>
      <div className="mt-4 flex items-center gap-3">
        <div className="h-9 w-9 rounded-full bg-slate-900 text-white flex items-center justify-center text-xs font-extrabold">{t.name?.split(' ').map(w => w[0]).slice(0, 2).join('')}</div>
        <div className="min-w-0">
          <div className="text-sm font-bold text-slate-900 truncate">{t.name}</div>
          <div className="text-xs text-slate-500 truncate">{t.role}</div>
        </div>
      </div>
    </div>
  );

  const Row = ({ data, reverse }) => (
    <div className="relative overflow-hidden">
      <div className={`flex gap-5 ${reverse ? 'animate-[tmarqueeR_60s_linear_infinite]' : 'animate-[tmarquee_60s_linear_infinite]'} hover:[animation-play-state:paused]`} style={{ width: 'max-content' }}>
        {[...data, ...data].map((t, i) => <Card key={i} t={t} />)}
      </div>
    </div>
  );

  return (
    <section className="py-20 bg-slate-50 overflow-hidden" data-testid="testimonial-wall">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
        <span className="text-xs font-semibold uppercase tracking-widest text-orange-600">Client Love</span>
        <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900 flex items-center justify-center gap-2"><Quote className="h-7 w-7 text-orange-500" /> What leaders say about working with us</h2>
      </div>
      <div className="mt-10 space-y-5">
        <Row data={row1} />
        <Row data={row2} reverse />
      </div>
      <style>{`
        @keyframes tmarquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        @keyframes tmarqueeR { from { transform: translateX(-50%); } to { transform: translateX(0); } }
      `}</style>
    </section>
  );
};

export default TestimonialWall;
